import { useCallback, useEffect } from "react";
import { isAndroid, isIOS } from "react-device-detect";
import { Link, useLocation } from "react-router-dom";
import { PrimaryButton } from "./components";

import "./home.scss";
import { DOWNLOAD_URL } from ".";

function OpenInApp() {
  const location = useLocation();

  const openAppOrAppStore = useCallback(() => {
    if (!isIOS && !isAndroid) {
      window.open(DOWNLOAD_URL);
      return;
    }

    if (!window.open(`calshare://fr.swun.calshare${location.pathname}`)) {
      window.open(DOWNLOAD_URL);
    }
  }, [location.pathname]);

  useEffect(() => {
    openAppOrAppStore();
  });

  return (
    <div id="open-app-links">
      <PrimaryButton onClick={openAppOrAppStore}>
        Ouvrir dans l'app
      </PrimaryButton>
      <Link to={DOWNLOAD_URL}>Télécharger Calshare</Link>
    </div>
  );
}

export default OpenInApp;
